import { useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
// import { Menu, X, Mail, Phone, MapPin } from "lucide-react";
import { Menu, X } from "lucide-react";
// import {
//   // FaFacebook,
//   FaInstagram,
//   // FaLinkedin,
//   // FaTiktok,
//   // FaYoutube,
//   // FaTwitter,
// } from "react-icons/fa";
import Logo from "../Assets/Logo.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/your-practitioner", label: "Your Practitioner" },
  { to: "/services", label: "Services" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact-us", label: "Contact Us" },
  { to: "/faqs", label: "FAQ's" },
];

const SiteHeader = () => {
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      // console.log(window.scrollY);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  // Scroll to the top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };

  return (
    <header className="HeaderParent">
      {/* <div className="Header_Contact_SocialMedia_Box">
        <div className="Header_Contact_BoxDiv">
          <p className="Header_Section_IconTitleContent_Content animate-top">
            <Phone className="Header_Section_HighestIcon" />
            <a href="tel:+16104127940" className="Header_Contact_link">
              +1 (610) 412-7940
            </a>
          </p>

          <p className="Header_Section_IconTitleContent_Content animate-top">
            <Mail className="Header_Section_HighestIcon" />
            <a
              href="mailto:wellnessdestinationhomeopathy@gmail.com"
              className="Header_Contact_link"
            >
              wellnessdestinationhomeopathy@gmail.com
            </a>
          </p>

          <p className="Header_Section_IconTitleContent_Content animate-top">
            <MapPin className="Header_Section_HighestIcon" />
            <a
              href="https://www.google.com/maps/search/?api=1&query=Suite+106-H+801+Springdale+Dr+Exton,+PA+19341"
              target="_blank"
              rel="noopener noreferrer"
              className="Header_Contact_link"
            >
              Suite 106-H 801 Springdale Dr Exton, PA 19341
            </a>
          </p>
        </div>
        <div className="Header_SocialMedia_BoxDiv">
          <span className="Header_SocialMedia_BoxDivSpan">
                        <a
              href="https://www.instagram.com/p/DXSfegnDtY0/?img_index=3&igsh=MTBpcmsxZmh5YmZrMQ=="
              className="Header_Section_SMIcon_aTag"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram className="Header_Section_SMIcon" />
            </a>
          </span>

        </div>
      </div> */}
      <div className="HeaderBox">
        {/* Logo */}
        <Link to="/" className="HeaderLogoContent">
          <div className="HeaderLogoDiv">
            <img src={Logo} alt="Logo" className="HeaderLogo" />
          </div>
          <span className="HeaderLogoContentDiv">
            <span className="HeaderLogoContentTop">
              The Wellness Destination
            </span>
            <span className="HeaderLogoContentBottom">Homeopathy, LLC</span>
          </span>
        </Link>

        {/* Desktop Menu */}
        <div className="WebsiteHeaderMenuListDiv" onClick={scrollToTop}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `WebsiteHeaderMenuListDiv_MenuList ${
                  isActive ? "activeMenu" : ""
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}

          {/* CTA Button */}
          <Link to="/contact-us" className="WebsiteHeaderMenuListDiv_Button">
            Book Consultation
          </Link>
        </div>

        {/* Mobile Toggle Button */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="MobileHeaderMenuListDiv"
          // aria-label="Toggle menu"
        >
          {open ? (
            <X className="MobileHeaderMenuListDiv_Button" />
          ) : (
            <Menu className="MobileHeaderMenuListDiv_Button" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="MobileHeaderMenuListDiv_Parent" ref={menuRef}>
          <div className="MobileHeaderMenuListDiv_Box">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => {
                  scrollToTop();
                  setOpen(false);
                }}
                className={({ isActive }) =>
                  `MobileHeaderMenuListDiv_BoxList ${isActive ? "activeMenu" : ""}`
                }
              >
                {l.label}
              </NavLink>
            ))}

            {/* Mobile CTA */}
            <Link
              to="/contact-us"
              className="WebsiteHeaderMenuListDiv_Button"
              onClick={() => {
                scrollToTop();
                setOpen(false);
              }}
            >
              Book Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default SiteHeader;
